/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Weitere Informationen",
  "CookieMessage.old.text":
    "Wir verwenden Cookies, um eine optimale Funktionsweise unseres Webshops zu gewährleisten. Lesen Sie unsere Cookie-Richtlinien.",
  "CookieMessage.link": "Cookies akzeptieren",
  "CookieMessage.more_information": "Hier erfahren Sie mehr über Kramp Cookies",
  "CookieMessage.return": "Zurück",
  "CookieMessage.intro.body":
    "\n     Diese Cookies werden von uns und von Dritten platziert. Natürlich genießen Ihre persönlichen Daten dabei besonderen Schutz.\n     Wenn Sie unten auf „Cookies akzeptieren“ klicken, erklären Sie sich mit der Nutzung dieser Cookies einverstanden.\n     Die Annahme von Cookies sorgt für die optimale Funktion dieser Website. Das gilt beispielsweise für:\n    ",
  "CookieMessage.intro.list.1": "Automatische Anmeldung bei „Mein Konto“",
  "CookieMessage.intro.list.2":
    "Analyse des Nutzerverhaltens zur Verbesserung dieser Website",
  "CookieMessage.intro.list.3":
    "Erstellung von Kundenprofilen, sodass wir Ihnen personalisierte Angebote und Werbemitteilungen anbieten können",
  "CookieMessage.intro.extra":
    'Sie möchten nicht alle Cookies annehmen? Dann können Sie dies in <a>Ihren Einstellungen</a> selbst anpassen. Nähere Informationen finden Sie in unserer <a href="{legalLink}">Datenschutz- und Cookie-Erklärung.</a>',
  "CookieMessage.intro.title": "Kramp verwendet Cookies",
  "CookieMessage.settings.body":
    "Sie haben die Wahl zwischen drei Cookie-Einstellungen. Mit der Einstellung „Vollständig“ können wir Ihnen die beste Website bieten.",
  "CookieMessage.settings.standard.title": "Standard (am häufigsten gewählt)",
  "CookieMessage.settings.standard.body":
    "Cookies für Anmeldung, Bestellung, Analyse, persönliche Angebote, soziale Medien sowie Cookies von anderen Parteien innerhalb und außerhalb Europas.",
  "CookieMessage.settings.restricted.title": "Eingeschränkt",
  "CookieMessage.settings.restricted.body":
    "Cookies für Anmeldung, Bestellung, Analyse und persönliche Angebote.",
  "CookieMessage.settings.highly_restricted.title": "Stark eingeschränkt",
  "CookieMessage.settings.highly_restricted.body":
    "Sie lassen so wenige Cookies wie möglich zu. Nur für Anmeldung, Bestellung und eine zufriedenstellend funktionierende Website.",
  "CookieMessage.settings.options.title": "Was wir tun:",
  "CookieMessage.settings.option.1":
    "Cookies einsetzen, damit die Website gut funktioniert",
  "CookieMessage.settings.option.2": "Anonyme Statistiken führen",
  "CookieMessage.settings.option.3": "Benutzeranalysen",
  "CookieMessage.settings.option.4": "Interessante Informationen anzeigen",
  "CookieMessage.settings.option.5": "Persönliche Statistiken führen",
  "CookieMessage.settings.option.6": "Informationen zu Werbezwecken einsetzen",
  "CookieMessage.settings.option.7": "Persönliche Angaben gemeinsam nutzen",
  "CookieMessage.settings.title": "Cookie-Einstellungen",
  "CookiePage.url": "datenschutz-und-cookieerklaerung",
};
